/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskBOYEOYAmt
 */
export interface ExecRiskBOYEOYAmt {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskBOYEOYAmt
     */
    boy_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskBOYEOYAmt
     */
    eoy_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskBOYEOYAmt interface.
 */
export function instanceOfExecRiskBOYEOYAmt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskBOYEOYAmtFromJSON(json: any): ExecRiskBOYEOYAmt {
    return ExecRiskBOYEOYAmtFromJSONTyped(json, false);
}

export function ExecRiskBOYEOYAmtFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskBOYEOYAmt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'boy_amt': !exists(json, 'boy_amt') ? undefined : json['boy_amt'],
        'eoy_amt': !exists(json, 'eoy_amt') ? undefined : json['eoy_amt'],
    };
}

export function ExecRiskBOYEOYAmtToJSON(value?: ExecRiskBOYEOYAmt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'boy_amt': value.boy_amt,
        'eoy_amt': value.eoy_amt,
    };
}

